import React from 'react';
import { Link } from "gatsby";
import { Facebook, Instagram, ArrowUp } from "lucide-react";
import logo from "@/assets/logo.svg";
import TelLink from "./TelLink";

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="bg-black text-zinc-400 pt-16 pb-8">
      <div className="container mx-auto px-6">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {/* Logo and Contact Info */}
          <div className="space-y-6">
            <img
              src={logo}
              alt="Y3 Smiles Dental Logo"
              width={160}
              height={48}
              className="h-12 w-auto transition-gentle hover:scale-105 hover:drop-shadow-lg"
              loading="lazy"
              decoding="async"
            />
            <div className="space-y-2 text-sm">
              <p>
                <span className="uppercase text-[#B59682]">Phone:</span>{" "}
                <TelLink
                  clickSource="footer"
                  className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block"
                >
                  03 9022 4442
                </TelLink>
              </p>
              <p>
                <span className="uppercase text-[#B59682]">Email:</span>{" "}
                <a href="mailto:smile@y3smilesdental.com.au" rel="nofollow noreferrer" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">
                  smile@y3smilesdental.com.au
                </a>
              </p>
              <div>
                <p className="uppercase text-[#B59682] mb-1">Address:</p>
                <a
                  href="https://www.google.com/search?sca_esv=de45a14deaa8af91&rlz=1C1CHBF_enAU1057AU1057&sxsrf=AE3TifMcuyWLUIujqzA7WtMLRs3p-Uus2w%3A1760258388705&q=Y3%20Smiles%20Dental&stick=H4sIAAAAAAAAAONgU1I1qDAxMEpMS0xMMzJNSk41NDe3MqhIM7ZMsTA0MrFIMTJJtDRMWcQqEGmsEJybmZNarOCSmleSmAMAQyVofDwAAAA&mat=CUKdJZUYoj6X&ved=2ahUKEwiT3uK_oZ6QAxXc4zgGHVCbFsUQrMcEegQIQRAC"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block cursor-pointer"
                >
                  <p>Unit 1, 34 KING WILLIAM ST,</p>
                  <p>BROADMEADOWS, VIC 3047</p>
                </a>
              </div>
            </div>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-sm uppercase mb-4 tracking-wider text-[#B59682]">Opening Hours</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between hover:bg-white/5 px-2 py-1 rounded transition-gentle">
                <span>MONDAY:</span>
                <span>9:00 AM - 5:30 PM</span>
              </div>
              <div className="flex justify-between hover:bg-white/5 px-2 py-1 rounded transition-gentle">
                <span>TUESDAY:</span>
                <span>9:00 AM - 5:30 PM</span>
              </div>
              <div className="flex justify-between hover:bg-white/5 px-2 py-1 rounded transition-gentle">
                <span>WEDNESDAY:</span>
                <span>9:00 AM - 5:30 PM</span>
              </div>
              <div className="flex justify-between hover:bg-white/5 px-2 py-1 rounded transition-gentle">
                <span>THURSDAY:</span>
                <span>9:00 AM - 5:30 PM</span>
              </div>
              <div className="flex justify-between hover:bg-white/5 px-2 py-1 rounded transition-gentle">
                <span>FRIDAY:</span>
                <span>9:00 AM - 5:30 PM</span>
              </div>
              <div className="flex justify-between hover:bg-white/5 px-2 py-1 rounded transition-gentle">
                <span>SATURDAY:</span>
                <span>9:00 AM - 1:00 PM</span>
              </div>
              <div className="flex justify-between hover:bg-white/5 px-2 py-1 rounded transition-gentle">
                <span>SUNDAY:</span>
                <span>CLOSED</span>
              </div>
            </div>
          </div>

          {/* Locations */}
          <div>
            <h3 className="text-sm uppercase mb-4 tracking-wider text-[#B59682]">Locations</h3>
            <div className="grid grid-cols-1 gap-2 text-sm">
              <Link to="/locations/broadmeadows" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block font-semibold">Broadmeadows (Clinic)</Link>
              <Link to="/locations/glenroy" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Glenroy</Link>
              <Link to="/locations/craigieburn" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Craigieburn</Link>
              <Link to="/locations/greenvale" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Greenvale</Link>
              <Link to="/locations/campbellfield" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Campbellfield</Link>
              <Link to="/locations/roxburgh-park" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Roxburgh Park</Link>
              <Link to="/locations/meadow-heights" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Meadow Heights</Link>
              <Link to="/locations/hadfield" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Hadfield</Link>
              <Link to="/locations/westmeadows" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Westmeadows</Link>
              <Link to="/locations/gladstone-park" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Gladstone Park</Link>
              <Link to="/locations/fawkner" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Fawkner</Link>
              <Link to="/locations/mickleham" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Mickleham</Link>
              <Link to="/service-areas" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">View all service areas →</Link>
            </div>
          </div>

          {/* Treatments */}
          <div>
            <h3 className="text-sm uppercase mb-4 tracking-wider text-[#B59682]">Treatments</h3>
            <div className="grid grid-cols-1 gap-2 text-sm">
              <Link to="/treatments" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block font-semibold">View All Treatments</Link>
              <Link to="/treatments/dental-implants" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Dental Implants</Link>
              <Link to="/treatments/teeth-whitening" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Teeth Whitening</Link>
              <Link to="/treatments/childrens-dentistry" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Children's Dentistry</Link>
              <Link to="/treatments/emergency" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Emergency Dentistry</Link>
              <Link to="/treatments/wisdom-teeth" className="hover:text-[#B59682] transition-gentle hover:scale-105 inline-block">Wisdom Teeth</Link>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-zinc-800 mb-8" />

        {/* Social Links - Centered */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-8">
            <a
              href="https://www.facebook.com/people/Y3-Smiles-Dental/61579053037448/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-400 hover:text-[#B59682] transition-gentle transform hover:scale-125 hover:-translate-y-1"
              aria-label="Visit Y3 Smiles Dental on Facebook"
            >
              <Facebook className="h-8 w-8" />
            </a>
            <a
              href="https://www.instagram.com/y3_smilesdental/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-zinc-400 hover:text-[#B59682] transition-gentle transform hover:scale-125 hover:-translate-y-1"
              aria-label="Visit Y3 Smiles Dental on Instagram"
            >
              <Instagram className="h-8 w-8" />
            </a>
          </div>
        </div>

        {/* Business Verification & Disclaimer */}
        <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 mb-8 max-w-3xl mx-auto">
          <div className="text-center space-y-3">
            <h4 className="text-[#B59682] font-semibold uppercase text-sm tracking-wider">Verified Australian Dental Practice</h4>
            <div className="text-xs text-zinc-400 space-y-2">
              <p className="text-zinc-300"><strong>ABN:</strong> 49 137 405 383 | <strong>Business Name:</strong> Y3 Smiles Dental</p>
              <p className="text-zinc-300"><strong>Registered Address:</strong> Unit 1, 34 King William Street, Broadmeadows VIC 3047</p>
              <div className="border-t border-zinc-800 pt-3 mt-3">
                <p className="text-yellow-500 font-medium">⚠️ IMPORTANT NOTICE</p>
                <p className="mt-1">Y3 Smiles Dental is a <strong className="text-white">private dental practice</strong>. We are <strong className="text-white">NOT affiliated with or operated by the Australian Government</strong>. We are an approved provider that accepts Medicare's Child Dental Benefits Schedule (CDBS) for eligible children, but we are an independent business.</p>
              </div>
              <p className="text-zinc-400">
                Information on this website is general in nature and does not constitute dental or medical advice.
                Individual treatment suitability will be assessed by a registered dentist. Language support availability may vary
                and should be requested at the time of booking.
              </p>
            </div>
          </div>
        </div>

        {/* Footer Credits */}
        <div className="text-center text-xs space-y-1">
          <div>COPYRIGHT © 2025 Y3 SMILES DENTAL. ALL RIGHTS RESERVED.</div>
          <div className="flex justify-center gap-6 text-zinc-400">
            <Link to="/news-and-articles" className="hover:text-[#B59682] transition-gentle">News & Articles</Link>
            <Link to="/privacy-policy" className="hover:text-[#B59682] transition-gentle">Privacy Policy</Link>
          </div>
          <div className="text-zinc-400">
            Powered by <a href="https://psei.com.au" target="_blank" rel="noopener noreferrer" className="hover:text-[#B59682] transition-gentle">PSEI Australia</a>
          </div>
        </div>

        {/* Scroll to Top */}
        <button
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 bg-booking-gold text-white p-3 rounded-full transition-gentle transform hover:scale-110 hover:shadow-hover hover:bg-[#A4846F] z-50"
          aria-label="Scroll to top"
        >
          <ArrowUp className="h-5 w-5" />
        </button>
      </div>
    </footer>
  );
};

export default Footer;
